import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    ViewEncapsulation,
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { isDefined } from '../utils';
import { Observable, Subject } from 'rxjs';
import {
    FiPasswordValidationProgressHelperService,
    IPasswordValidationProgressDisplayData,
} from './password-validation-progress-helper.service';

@Component({
    selector: 'fi-password-validation-progress',
    templateUrl: './password-validation-progress.component.html',
    styleUrls: ['./password-validation-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-password-validation-progress' },
    standalone: false,
})
export class FiPasswordValidationProgressComponent implements OnDestroy {
    private passwordModel: NgModel;
    @Input({ required: true }) set PasswordModel(value: NgModel) {
        if (value) {
            this.passwordModel = value;
            this.detectChangesOnValuesChanges(value.valueChanges);
        }
    }

    private confirmPasswordModel: NgModel;
    @Input() set ConfirmPasswordModel(value: NgModel) {
        if (value) {
            this.confirmPasswordModel = value;
            this.detectChangesOnValuesChanges(value.valueChanges);
        }
    }

    constructor(
        private cdr: ChangeDetectorRef,
        private fiPasswordValidationProgressHelperService: FiPasswordValidationProgressHelperService,
    ) {}

    private detectChangesOnValuesChanges(valueChangesObs: Observable<any>) {
        valueChangesObs.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => this.cdr.markForCheck());
    }

    isConfirmPasswordDefined(): boolean {
        return isDefined(this.confirmPasswordModel);
    }

    getPasswordStrengthValidationDisplayData(): IPasswordValidationProgressDisplayData {
        return this.fiPasswordValidationProgressHelperService.getPasswordStrengthValidationDisplayData(
            this.passwordModel?.value,
            this.passwordModel?.errors,
        );
    }

    getPasswordMinLengthValidationDisplayData(): IPasswordValidationProgressDisplayData {
        return this.fiPasswordValidationProgressHelperService.getPasswordMinLengthValidationDisplayData(
            this.passwordModel?.value,
            this.passwordModel?.errors,
        );
    }

    getConfirmPasswordValidationDisplayData(): IPasswordValidationProgressDisplayData {
        return this.fiPasswordValidationProgressHelperService.getConfirmPasswordValidationDisplayData(
            this.confirmPasswordModel?.value,
            this.confirmPasswordModel?.errors,
        );
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
